/* eslint-disable no-unused-vars */
import axios from 'axios'

import { CHECKSIZE as ENDPOINT } from '../common/endpoints'
import { success, error } from '../main/toast-notifications'
import { t } from '../main/i18n'
import { createLightbox, updateContent } from '../main/lightbox'

const targetClass = '.j-lightbox__sizes'
const targetBtn = document.querySelector('.j-open--sizes')
const lightbox = document.querySelector(targetClass)
const infoForm = lightbox.querySelector('form')
let lightboxInstance

const bindEvents = (infoForm) => {
	infoForm.addEventListener('submit', requestSizeWithToken)
}

const removeEvents = (infoForm) => {
	infoForm.removeEventListener('submit', requestSizeWithToken)
}

const requestSizeWithToken = (evt) => {
	
	evt.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {

			const tokenField = document.querySelector('.g-recaptcha-token')
			tokenField.value = token
			handleSubmit(evt)

		})
	})
}

const handleSubmit = async (e) => {
	e.preventDefault()
	const Product = window.motostorm?.product || {}
	const Lang = window.motostorm?.lang
	const formData = Array.from(e.target.elements).reduce((fd, el) => ({ ...fd, [el.name]: el.value }))
	const token = document.querySelector('.g-recaptcha-token')?.value

	try {
		const res = await axios.post(ENDPOINT, {
			data: {
				...Product,
				Lang,
				...formData,
				token
			},
		})
		// display toast notification (remove this line if you prefer to display the response from the service)
		success(t('size-success'))
		// update form content (remove this line if the success notification is enough)
		// updateContent(res.data, lightboxInstance, bindEvents, removeEvents)
		// and/or automatically close the lightbox
		lightboxInstance.close()
	} catch (err) {
		console.error(`${err.name}: ${err.message}`)
		error(t('size-error'))
	}
}

const init = () => {
	// bind events before the lightbox is removed from DOM
	if (targetBtn && lightbox) {
		bindEvents(infoForm)
		lightboxInstance = createLightbox(targetBtn, targetClass)
	}
}

init()
/* eslint-enable no-unused-vars */
